import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import storage from "../../services/storage";
import "./index.css";
import { useNavigate } from "react-router-dom";
import { useLoad } from "../../context";
import { useLocation } from "react-router-dom";
import { filterProductsByUserCategory } from "../../utils/categoryFilter";
import CardProduto from "../../Components/CardProduto";

export default function VitrineLeo() {
  const [user] = useState(storage.get("USUARIO")?.loginResponse);
  const [saldo, setSaldo] = useState(0);
  const [mostrarSaldo, setMostrarSaldo] = useState(false);
  const [statusAndamento, setStatusAndamento] = useState(false);
  const [listaCategoria, setListaCategoria] = useState([]);
  const [listaProdutos, setListaProdutos] = useState([]);
  const params = useLocation();
  const navigate = useNavigate();
  const pathname = params.pathname;

  const [listaProdutosMaisProcurados, setListaProdutosMaisProcurados] =
    useState([]);
  const [filtro, setFiltro] = useState({
    disponivel: true,
    descricao: "",
    sku: "",
    categoriaId: "",
    pontos: "",
  });
  const [itensVisiveis, setItensVisiveis] = useState(15);

  const { load, setLoad } = useLoad();

  async function fnCarregarSaldo() {
    var init = {
      token: user?.token,
      mes: "",
      ano: "",
    };
    try {
      setLoad(true);
      let response = await ApiServices.apiPost("vitrineorder/saldo", init);
      setSaldo(response.data.balance);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnListaCategoria() {
    try {
      let response = await ApiServices.apiGet("produto/filtro-categorias");

      setListaCategoria(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
    }
  }
  async function fnListaProdutos() {
    setListaProdutos([]);
    try {
      setLoad(true);

      const pontos = window.location.pathname.includes("/campanha")
        ? 5
        : filtro.pontos;

      let response = await ApiServices.apiGet(
        `produto/de-produto?disponivel=${filtro.disponivel}&descricao=${filtro.descricao}&categoriaId=${filtro.categoriaId}&pontos=${pontos}&sku=${filtro.sku}`
      );

      // Filter products based on user's category
      const filteredProducts = filterProductsByUserCategory(response.data);
      setListaProdutos(filteredProducts);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }
  async function fnListaProdutosMaisProcurados() {
    try {
      const pontos = window.location.pathname.includes("/campanha") ? 5 : 1;

      let response = await ApiServices.apiGet(
        `produto/de-produto?disponivel=true&descricao=&categoriaId=&pontos=${pontos}`
      );

      // Filter products based on user's category
      const filteredProducts = filterProductsByUserCategory(response.data);
      setListaProdutosMaisProcurados(filteredProducts);
    } catch (err) {
      console.error("err", err);
    } finally {
      window.scrollTo(0, 0);
    }
  }
  async function fnStatusAndamento() {
    try {
      let response = await ApiServices.apiGet(
        `campanhav2/por-regra?idregracampanha=7F4C3909-0756-4B8A-A63F-E9595C3CBA27`
      );
      let emAndamento = response.data.filter(
        (e) => e.status === "Em andamento"
      );
      console.log(emAndamento.length);
      setStatusAndamento(emAndamento.length >= 1 ? true : false);
    } catch (err) {
      console.error("err", err);
    }
  }
  function fnMostrarSaldo() {
    if (mostrarSaldo) {
      setMostrarSaldo(false);
    } else {
      setMostrarSaldo(true);
      fnCarregarSaldo();
    }
  }
  function fnBtnFiltrar() {
    setItensVisiveis(15); // Resetar para 15 itens ao filtrar
    fnListaProdutos();
  }

  function fnVerMais() {
    setItensVisiveis((prev) => prev + 15);
  }
  useEffect(() => {
    storage.set("IR-CAMPANHA", false);
    fnCarregarSaldo();
    fnListaCategoria();
    fnListaProdutos();
    fnListaProdutosMaisProcurados();
    fnStatusAndamento();
    window.scrollTo(0.0, 0.0);
  }, [pathname]); //eslint-disable-line react-hooks/exhaustive-deps

  // useEffect para recarregar produtos quando o filtro mudar
  useEffect(() => {
    if (listaCategoria.length > 0) {
      setItensVisiveis(15); // Resetar para 15 itens ao mudar categoria
      fnListaProdutos();
    }
  }, [filtro.categoriaId]);

  return (
    <>
      {filtro.categoriaId === "4f483851-3106-496c-8227-55f0994d76c5" && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            backgroundColor: "#ffd300",
            padding: "0px",
            fontWeight: "bold",
            fontSize: "20px",
            color: "#000",
            textAlign: "center",
            marginBottom: "20px",
          }}
        >
          Drible Time de Craques
        </div>
      )}
      <div className="d-flex justify-content-center mt-3 ">
        <div className="container divProdutos vitrineContainer">
          <div>
            <div className="maisProcurados"></div>
            {filtro.categoriaId !== "4f483851-3106-496c-8227-55f0994d76c5" && (
              <div className="row vitrineFiltros">
                <div className="col-md-5">
                  <button
                    className="btn btn-warning"
                    onClick={() => {
                      setFiltro((prevState) => ({
                        ...prevState,
                        categoriaId: "4f483851-3106-496c-8227-55f0994d76c5",
                      }));
                    }}
                  >
                    Drible Time de Craques
                  </button>
                </div>
              </div>
            )}
            <div className="row vitrineFiltros">
              <div className="col-12">
                <h3>
                  <b>Buscar </b>produtos
                </h3>
              </div>
            </div>
            <div className="row vitrineFiltros align-items-center">
              <div className="col-md-3 d-flex align-items-center">
                <select
                  value={filtro.categoriaId}
                  onChange={(e) => {
                    setFiltro((prevState) => ({
                      ...prevState,
                      categoriaId: e.target.value,
                    }));
                  }}
                  className="form-select"
                >
                  <option value={""}>Categorias</option>
                  {listaCategoria.map((e, i) => (
                    <option key={i} value={e.produtoCategoriaId}>
                      {e.categoria}
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-3 d-flex align-items-center campo-busca">
                <input
                  type="text"
                  placeholder="O que você procura na Leo?"
                  onChange={(e) => {
                    const value = e.target.value;
                    const isSku = /^\d+$/.test(value); // Verificar se o texto parece ser um SKU
                    setFiltro((prevState) => ({
                      ...prevState,
                      descricao: value,
                      sku: isSku ? value : "", // Definir o SKU apenas se for um número
                    }));
                  }}
                  className="form-control"
                />
              </div>
              <div className="col-md-3 d-flex align-items-center">
                <select
                  onChange={(e) => {
                    setFiltro((prevState) => ({
                      ...prevState,
                      pontos: e.target.value,
                    }));
                  }}
                  className="form-select"
                >
                  <option value={""}>Todos</option>
                  <option value={1}>Mais Procurados</option>
                  <option value={2}>Maior Valor</option>
                  <option value={3}>Menor Valor</option>
                  <option value={4}>Mais Novos</option>
                  {statusAndamento && (
                    <option value={5}>Resgate Promocional</option>
                  )}
                </select>
              </div>
              <div className="col-md-3 d-flex align-items-center">
                <button
                  onClick={fnBtnFiltrar}
                  className="btn btn-warning w-100 "
                  style={{
                    maxHeight: "38px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  BUSCAR
                </button>
              </div>
            </div>

            <div className="todosProdutos">
              {listaProdutos?.slice(0, itensVisiveis).map((e, i) => {
                const customRoute =
                  filtro.categoriaId === "4f483851-3106-496c-8227-55f0994d76c5"
                    ? "/catalogo/vitrine-leo-time-de-craque/" + e.produtoId
                    : "/catalogo/vitrine-leo/" + e.produtoId;

                return (
                  <CardProduto key={i} product={e} customRoute={customRoute} />
                );
              })}
            </div>
            <div className="row d-flex justify-content-center">
              <div className="col-md-3">
                {listaProdutos?.length > itensVisiveis && (
                  <div className="d-flex justify-content-center mt-4 mb-4">
                    <button
                      onClick={fnVerMais}
                      className="btn btn-warning btn-lg"
                      style={{
                        minWidth: "200px",
                        padding: "12px 32px",
                        fontSize: "16px",
                        fontWeight: "700",
                      }}
                    >
                      VER MAIS
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
